// Permission catalogue rendered in the Pantry User module (invite dialog +
// detail drawer). Backend strings match what the API stores in `custom_roles`.

import { USER_ROLE_IDS } from './constants'

export const PERMISSION_IDS = {
  DASHBOARD: 'breadstack_dashboard',
  PRODUCTS: 'breadstack_product',
  ORDERS: 'breadstack_order',
  CUSTOMERS: 'breadstack_customer',
  MEDIA: 'breadstack_media_library',
  CATEGORIES: 'breadstack_pantry_category',
  BRANDS: 'breadstack_pantry_brands',
  TAGS: 'breadstack_pantry_tags',
  REVIEWS: 'breadstack_pantry_reviews',
  LOYALTY: 'breadstack_pantry_loyalty',
  STOREFRONT_ANALYTICS: 'breadstack_pantry_storefront_analytics',
  EDITOR: 'pantry_builder_editor',
} as const

export type PermissionId = (typeof PERMISSION_IDS)[keyof typeof PERMISSION_IDS]

// Ordered list of every permission the UI knows about — used to render the
// checkbox grid and to build the `custom_roles` boolean map for the backend.
export const PANTRY_STORE_PERMISSIONS: PermissionId[] = [
  PERMISSION_IDS.DASHBOARD,
  PERMISSION_IDS.PRODUCTS,
  PERMISSION_IDS.CATEGORIES,
  PERMISSION_IDS.BRANDS,
  PERMISSION_IDS.TAGS,
  PERMISSION_IDS.REVIEWS,
  PERMISSION_IDS.CUSTOMERS,
  PERMISSION_IDS.ORDERS,
  PERMISSION_IDS.LOYALTY,
  PERMISSION_IDS.STOREFRONT_ANALYTICS,
  PERMISSION_IDS.EDITOR,
  PERMISSION_IDS.MEDIA,
]

export const PERMISSION_LABELS: Record<string, string> = {
  [PERMISSION_IDS.DASHBOARD]: 'Dashboard',
  [PERMISSION_IDS.PRODUCTS]: 'Products',
  [PERMISSION_IDS.ORDERS]: 'Orders',
  [PERMISSION_IDS.CUSTOMERS]: 'Customers',
  [PERMISSION_IDS.MEDIA]: 'Asset Library',
  [PERMISSION_IDS.CATEGORIES]: 'Categories',
  [PERMISSION_IDS.BRANDS]: 'Brands',
  [PERMISSION_IDS.TAGS]: 'Tags',
  [PERMISSION_IDS.REVIEWS]: 'Reviews',
  [PERMISSION_IDS.LOYALTY]: 'Loyalty',
  [PERMISSION_IDS.STOREFRONT_ANALYTICS]: 'Analytics',
  [PERMISSION_IDS.EDITOR]: 'Website Editor',
}

// Default permissions granted by each role — used to seed the permission
// checkboxes when the user picks a role.
export const ROLE_PERMISSION_PRESETS: Record<string, PermissionId[]> = {
  [USER_ROLE_IDS.GENERAL_MANAGER]: [...PANTRY_STORE_PERMISSIONS],
  [USER_ROLE_IDS.MARKETING_MANAGER]: [...PANTRY_STORE_PERMISSIONS],
  [USER_ROLE_IDS.MARKETING_AGENT]: [
    PERMISSION_IDS.PRODUCTS,
    PERMISSION_IDS.CATEGORIES,
    PERMISSION_IDS.BRANDS,
    PERMISSION_IDS.TAGS,
    PERMISSION_IDS.REVIEWS,
    PERMISSION_IDS.CUSTOMERS,
    PERMISSION_IDS.ORDERS,
    PERMISSION_IDS.MEDIA,
  ],
  [USER_ROLE_IDS.SERVICE_MANAGER]: [
    PERMISSION_IDS.ORDERS,
    PERMISSION_IDS.CUSTOMERS,
  ],
  [USER_ROLE_IDS.SERVICE_AGENT]: [
    PERMISSION_IDS.ORDERS,
    PERMISSION_IDS.CUSTOMERS,
  ],
  // CUSTOM_ROLE has no preset — it's whatever the user has currently checked.
}
